import { PageFooter } from '../components/layout/PageFooter';
import { product, support, supportTopics } from '../business/content/siteContent';
import './MainPage.css';
import './PrivacyPage.css';
import './SupportPage.css';

export function SupportPage() {
  return (
    <div className="site-shell">
      <header className="privacy-header">
        <a className="brand" href="/" aria-label="NASLink トップページへ">
          <span className="brand-mark" aria-hidden="true">N</span>
          {product.name}
        </a>
      </header>

      <main className="privacy-main">
        <div className="privacy-intro">
          <p className="eyebrow">SUPPORT</p>
          <h1>サポート</h1>
          <p>
            NASLinkの設定や接続でお困りのときは、まず下記のよくある質問をご覧ください。
            解決しない場合は、メールでお気軽にお問い合わせください。
          </p>
        </div>

        <div className="support-contact">
          <div>
            <p className="support-contact-label">お問い合わせ</p>
            <a className="support-contact-email" href={`mailto:${support.email}`}>
              {support.email}
            </a>
            <p className="support-contact-note">{support.responseNote}</p>
          </div>
          <a className="support-contact-button" href={`mailto:${support.email}`}>
            メールを送る
          </a>
        </div>

        <article className="privacy-content">
          <section className="policy-section">
            <h2>スムーズなご案内のために</h2>
            <p>
              お問い合わせの際は、次の情報を添えていただけると、状況を把握しやすくなります。
            </p>
            <ul>
              {support.reportHints.map((hint) => (
                <li key={hint}>{hint}</li>
              ))}
            </ul>
          </section>

          {supportTopics.map((topic) => (
            <section className="policy-section" key={topic.title}>
              <h2>{topic.title}</h2>
              <ul>
                {topic.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </section>
          ))}

          <section className="policy-section">
            <h2>関連ページ</h2>
            <p>
              情報の取り扱いについては
              <a className="support-inline-link" href="/privacy">プライバシーポリシー</a>
              をご確認ください。
            </p>
          </section>
        </article>
      </main>

      <PageFooter productName={product.name} />
    </div>
  );
}
